<template>
  <ValidationProvider :name="$attrs.label" :rules="rules" v-slot="{ errors }">
    <v-select clearable v-model="innerValue" :error-messages="errors" v-bind="$attrs" v-on="$listeners">
      <template v-if="prependItems != null" v-slot:prepend-item>
        <v-list-item v-for="item in prependItems" :key="item.code">           
          <v-list-item-content>
            <v-list-item-title>
              <!-- better would be: item[$attrs.item-text] as defined the label property by caller -->
              {{item.name}} 
            </v-list-item-title>            
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
    prependItems: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
